import { useTranslation } from 'next-i18next'
import { GetServerSidePropsContext } from 'next'

import dynamic from 'next/dynamic'

import { useRouter } from 'next/router'

import Meta from '@/components/Meta'

import HaveParking from '@/components/sections/HaveParking'

import Hero from '@/components/navipay/Hero'
import Parking from '@/components/navipay/Parking'
import StarsWithOpinionsComponent from '@/components/navipay/StarsWithOpinions'
import Partners from '@/components/sections/Partners'
import HowItWorks from '@/components/navipay/HowItWorks'
import { loadTranslationsWithMarket } from '@/utils/loadTranslations'
import DefaultLayout from '@/components/layouts/Default'
import PopupOverlayView from '@/components/Popups/PopupOverlayView'
import { useMarket } from '@/utils/multi-markets/context'

const FaqSection = dynamic(() => import('@/components/sections/Faq'))

export const getServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  return loadTranslationsWithMarket(context, {
    cache: 'stale-while-revalidate',
    namespaces: ['common', 'opinions', 'navipay', 'popups', 'faq']
  })
}

function Navipay() {
  const { t, i18n } = useTranslation('navipay')
  const { locale } = useRouter()
  const commonTranslations = i18n.getResourceBundle(locale as string, 'faq')
  const { market } = useMarket()

  const faqCategories = commonTranslations?.categories.list
  return (
    <DefaultLayout>
      <Meta
        title={t('meta.title')}
        description={t('meta.description')}
        withoutPostfix
      />
      <div id="popup-wrapper" />
      <Hero />
      <Parking />
      <Partners />
      <HowItWorks />
      <StarsWithOpinionsComponent />

      {faqCategories && faqCategories?.length > 0 ? (
        <FaqSection forHomePage />
      ) : null}

      <Partners />
      <HaveParking />
      {market && market !== 'bh' && <PopupOverlayView />}
    </DefaultLayout>
  )
}

export default Navipay
